import {Svg} from "@/shared/ui/Svg";
import {ProductDeliveryAction} from "./ProductDeliveryAction";
import {DeliveryItem} from "../types";
import {DELIVERY_ICONS} from "../model/consts";
import styles from "./ProductDelivery.module.scss";

type Props = {
    item: DeliveryItem;
    productDataId: number;
};

export const ProductDeliveryItem = (
    {
        item,
        productDataId,
    }: Props
) => {
    return (
        <div className={styles.item}>
            <Svg id={DELIVERY_ICONS[item.key]} className={styles[`${[item.key]}Icon`]} />
            <div className={styles.content}>
                <ProductDeliveryAction item={item} productDataId={productDataId} />
                &nbsp;{item.text} {item.expressText && (<>&nbsp;или {item.expressText}</>)}
            </div>
        </div>
    );
}
